import { clsx } from 'clsx';

export function SegmentedControl({ options, value, onChange, className }) {
  return (
    <div className={clsx('inline-flex bg-surface-3 rounded p-0.5 gap-px', className)}>
      {options.map((opt) => {
        const optValue = typeof opt === 'object' ? opt.value : opt;
        const optLabel = typeof opt === 'object' ? opt.label : opt;
        const on = optValue === value;
        return (
          <button
            key={optValue}
            type="button"
            onClick={() => onChange?.(optValue)}
            className={clsx(
              'px-3 py-1 rounded-[5px] text-[11px] font-semibold transition-colors',
              on ? 'bg-surface text-gat-greenDark shadow-sm' : 'bg-transparent text-text-muted hover:text-text-dark'
            )}
          >
            {optLabel}
          </button>
        );
      })}
    </div>
  );
}
